import React, { FC } from 'react';
import styled from 'styled-components';

import MenuIcon from 'components/Icons/MenuIcon';

interface HamburgerProps {
  onToggleMenu: () => void;
}

const Hamburger: FC<HamburgerProps> = (props) => {
  const { onToggleMenu } = props;

  const toggleHamburgerMenu = () => {
    onToggleMenu();
  };

  return (
    <HamburgerBun onClick={toggleHamburgerMenu}>
      <MenuIcon />
    </HamburgerBun>
  );
};

const HamburgerBun = styled.div`
  display: none;
  position: relative;
  min-width: 20px;
  height: 35px;
  font-size: ${(props) => props.theme.font.size.extraLarge};
  text-transform: uppercase;
  justify-content: space-around;
  cursor: pointer;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.large}) {
    display: flex;
    align-items: center;
  }
`;

export default Hamburger;
